(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-faqs-page"] && !Shopify.designMode) return;
  try {
    
class FaqPage extends HTMLElement {
  static singleOpen = false;

  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('.faq-page__item'));
    this._tabsEl = this.querySelector('.faq-page__tabs');
    this._categoryLabel = this.querySelector('.faq-page__category-label');
    this._searchInput = this.querySelector('.faq-page__search-input');
    this._searchPopup = this.querySelector('.faq-page__search-popup');
    this._modal = this.querySelector('.faq-page__modal');
    this._modalTitle = this.querySelector('.faq-page__modal-title');
    this._modalAnswer = this.querySelector('.faq-page__modal-answer');

    this._buildTabs();
    this._bindSearch();
    this._bindModal();
    this._bindAccordion();
    this._bindCopyLinks();
    this._openFromUrl();
  }

  _buildTabs() {
    const seen = new Set();
    this._items.forEach((item) => { if (item.dataset.category) seen.add(item.dataset.category); });

    let orderList = [];
    try { orderList = JSON.parse(this.dataset.categoryOrder || '[]'); } catch (e) {}
    if (!Array.isArray(orderList) || !orderList.length) orderList = [...seen];

    const categories = orderList.filter((c) => seen.has(c));

    // Create the "All" tab first and set it as active
    const allBtn = document.createElement('button');
    allBtn.className = 'faq-page__tab';
    allBtn.setAttribute('role', 'tab');
    allBtn.setAttribute('aria-selected', 'true');
    allBtn.dataset.cat = 'all';
    allBtn.textContent = 'View All';
    allBtn.addEventListener('click', () => this._selectTab('all', allBtn));
    this._tabsEl.appendChild(allBtn);

    // Create specific category tabs
    categories.forEach((cat) => {
      const btn = document.createElement('button');
      btn.className = 'faq-page__tab';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', 'false');
      btn.dataset.cat = cat;
      btn.textContent = cat;
      btn.addEventListener('click', () => this._selectTab(cat, btn));
      this._tabsEl.appendChild(btn);
    });

    this._filterItems('all');
  }

  _selectTab(cat, btn) {
    this._tabsEl.querySelectorAll('.faq-page__tab').forEach((b) => {
      b.setAttribute('aria-selected', 'false');
    });
    btn.setAttribute('aria-selected', 'true');
    this._filterItems(cat);
  }

  _filterItems(cat) {
    this._categoryLabel.textContent = cat === 'all' ? 'All FAQs' : cat;

    // Filter group elements and toggle group titles appropriately
    const groups = Array.from(this.querySelectorAll('.faq-page__group'));
    groups.forEach((group) => {
      const visible = (cat === 'all' || group.dataset.category === cat);
      group.hidden = !visible;
      const titleEl = group.querySelector('.faq-page__group-title');
      if (titleEl) {
        titleEl.hidden = (cat !== 'all');
      }
    });

    this._items.forEach((item) => {
      const visible = (cat === 'all' || item.dataset.category === cat);
      item.hidden = !visible;
      if (!visible) {
        const d = item.querySelector('.faq-page__details');
        if (d) { d.classList.remove('active'); d.querySelector('.faq-page__question').setAttribute('aria-expanded', 'false'); }
      }
    });
  }

  _bindSearch() {
    this._searchInput.addEventListener('input', () => this._onSearch());
    this._searchInput.addEventListener('focus', () => {
      if (this._searchInput.value.trim()) this._onSearch();
    });
    this._searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this._closePopup();
    });
    document.addEventListener('click', (e) => {
      if (!this.querySelector('.faq-page__search-wrap').contains(e.target)) {
        this._closePopup();
      }
    });
  }

  _onSearch() {
    const q = this._searchInput.value.trim().toLowerCase();
    if (!q) { this._closePopup(); return; }

    const matches = this._items.filter((item) =>
      item.dataset.title.toLowerCase().includes(q)
    );

    this._searchPopup.innerHTML = '';

    if (matches.length === 0) {
      const msg = document.createElement('div');
      msg.className = 'faq-page__search-no-results';
      msg.textContent = 'No results found';
      this._searchPopup.appendChild(msg);
    } else {
      matches.forEach((item) => {
        const btn = document.createElement('button');
        btn.className = 'faq-page__search-result';
        btn.setAttribute('role', 'option');
        btn.textContent = item.dataset.title;
        btn.addEventListener('click', () => {
          this._closePopup();
          this._openModal(
            item.dataset.title,
            item.querySelector('.faq-page__answer-inner').innerHTML
          );
        });
        this._searchPopup.appendChild(btn);
      });
    }

    this._searchPopup.hidden = false;
  }

  _closePopup() {
    this._searchPopup.hidden = true;
    this._searchPopup.innerHTML = '';
  }

  _bindModal() {
    this.querySelector('.faq-page__modal-close').addEventListener('click', () => this._closeModal());
    this.querySelector('.faq-page__modal-backdrop').addEventListener('click', () => this._closeModal());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this._modal.hidden) this._closeModal();
    });
  }

  _openModal(title, answerHtml) {
    this._modalTitle.textContent = title;
    this._modalAnswer.innerHTML = answerHtml;
    this._modal.hidden = false;
    document.body.style.overflow = 'hidden';
    this.querySelector('.faq-page__modal-close').focus();
  }

  _closeModal() {
    this._modal.hidden = true;
    document.body.style.overflow = '';
  }

  _openFromUrl() {
    const handle = new URLSearchParams(window.location.search).get('entry');
    if (!handle) return;
    const btn = this.querySelector(`.faq-page__copy-btn[data-url="/pages/faqs?entry=${handle}"]`);
    if (!btn) return;
    const item = btn.closest('.faq-page__item');
    const details = item.querySelector('.faq-page__details');
    const question = details.querySelector('.faq-page__question');
    details.classList.add('active');
    question.setAttribute('aria-expanded', 'true');
    setTimeout(() => item.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
  }

  _bindCopyLinks() {
    this.querySelectorAll('.faq-page__copy-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const url = window.location.origin + btn.dataset.url;
        navigator.clipboard.writeText(url).then(() => {
          btn.classList.add('copied');
          setTimeout(() => btn.classList.remove('copied'), 2000);
        });
      });
    });
  }

  _bindAccordion() {
    this._items.forEach((item) => {
      const details = item.querySelector('.faq-page__details');
      const btn = details.querySelector('.faq-page__question');
      btn.addEventListener('click', () => {
        const isOpen = details.classList.contains('active');
        if (FaqPage.singleOpen) {
          this._items.forEach((other) => {
            const d = other.querySelector('.faq-page__details');
            d.classList.remove('active');
            d.querySelector('.faq-page__question').setAttribute('aria-expanded', 'false');
          });
        }
        if (!isOpen) {
          details.classList.add('active');
          btn.setAttribute('aria-expanded', 'true');
        } else if (!FaqPage.singleOpen) {
          details.classList.remove('active');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
}

customElements.define('faq-page', FaqPage);

  } catch(e) { console.error(e); }
})();
})();
